import Swiper from 'swiper/bundle';

const CaseStudies = () => {
    const sliders = document.querySelectorAll('.case-studies__swiper');
    if (!sliders.length) return;

    sliders.forEach((slider) => {
        // helper: keep only visible slides tabbable
        function updateSlideTabbing(sw) {
            sw.slides.forEach((slide) => {
                const isVisible =
                    slide.classList.contains('swiper-slide-visible') ||
                    slide.classList.contains('swiper-slide-active');

                const focusables = slide.querySelectorAll(
                    'a[href], button, input, select, textarea, [tabindex]'
                );

                focusables.forEach((el) => {
                    if (isVisible) {
                        if (el.getAttribute('tabindex') === '-1') {
                            el.removeAttribute('tabindex');
                        }
                    } else {
                        el.setAttribute('tabindex', '-1');
                    }
                });
            });
        }

        const parent = slider.closest('.case-studies');
        const slideCount = slider.querySelectorAll('.swiper-slide').length;

        // set centeredSlides false if less than 3 slides
        const shouldCenter = slideCount >= 3;

        const swiper = new Swiper(slider, {
            slidesPerView: 1.05,
            spaceBetween: 20,
            loop: false,
            centeredSlides: false,

            watchSlidesProgress: true,
            a11y: { enabled: true },
            keyboard: { enabled: true, onlyInViewport: true },

            navigation: {
                nextEl: parent.querySelector('.case-studies__nav--next'),
                prevEl: parent.querySelector('.case-studies__nav--prev'),
            },

            breakpoints: {
                1024: {
                    slidesPerView: 'auto',
                    centeredSlides: shouldCenter,
                    loop: shouldCenter,
                    spaceBetween: 50,
                },
            },

            on: {
                imagesReady() {
                    this.update();
                    updateSlideTabbing(this);
                },
                init() {
                    setTimeout(() => {
                        this.update();
                        if (shouldCenter) this.slideToLoop(0, 0);
                        updateSlideTabbing(this);
                    }, 50);
                },
                slideChange() {
                    updateSlideTabbing(this);
                },
                resize() {
                    updateSlideTabbing(this);
                },
                slidesLengthChange() {
                    updateSlideTabbing(this);
                },
                progress() {
                    updateSlideTabbing(this);
                },
            },
        });
    });
};

export default CaseStudies;
